import RouterView from '@/components/router-view.vue';
// component
import PurchaseProjectListCom from './purchase-project-list/purchase-project-list.vue';
import PurchaseProjectDetailCom from './purchase-project-detail/purchase-project-detail.vue';
import PurchaseConfirmAnnouncementCom from './purchase-confirm-announcement/purchase-confirm-announcement.vue';
import UploadAnnouncementImageCom from './upload-announcement-image/upload-announcement-image.vue';
import UploadPublicImageCom from './upload-public-image/upload-public-image.vue';
import CreateContractCom from './create-contract/create-contract.vue';
import ConfirmationLetterCom from './confirmation-letter/confirmation-letter.vue';
// router
import AuditApplyRouting from './audit-apply/audit-apply-routing.js';

export default [
  {
    path: 'list',
    name: 'purchaseProjectList',
    component: PurchaseProjectListCom,
    meta: {
      title: '我的采购项目',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'detail',
    name: 'purchaseProjectDetail',
    component: PurchaseProjectDetailCom,
    meta: {
      title: '我的采购项目详情',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'confirm-announcement',
    name: 'purchaseConfirmAnnouncement',
    component: PurchaseConfirmAnnouncementCom,
    meta: {
      title: '确认公告',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'upload-announcement-image',
    name: 'uploadAnnouncementImage',
    component: UploadAnnouncementImageCom,
    meta: {
      title: '上传公告照片',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'upload-public-image',
    name: 'uploadPublicImage',
    component: UploadPublicImageCom,
    meta: {
      title: '上传公示照片',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'create-contract',
    name: 'createContract',
    component: CreateContractCom,
    meta: {
      title: '创建合同',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'confirmation-letter',
    name: 'confirmationLetter',
    component: ConfirmationLetterCom,
    meta: {
      title: '确认竞价结果',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'audit-apply',
    name: 'auditApply',
    redirect: '/person-center/purchase-business/purchase-project/audit-apply/list',
    component: RouterView,
    meta: {
      title: '报名审核'
    },
    children: AuditApplyRouting
  }
];

